import {useCallback, useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import tinySyn from "../../img/Synergist_Emblem_Outline_black.svg";
import {Affix, Dropdown, Header, Tooltip, Whisper} from "rsuite";
import React from "react";
import {CLOSED_WIDTH, EXPANDED_WIDTH} from "../constants/navWidths"
import MenuIcon from '@rsuite/icons/Menu';
import {setExpanded} from "../../redux/sideNavSlice";
import {ArrowDownLine, InfoOutline} from "@rsuite/icons";
import TopNavInfoModal from "../modals/TopNavInfoModal";
import useLocalStorage from "react-use-localstorage";

const outerHeaderWrapperCss = {
    backgroundColor: "#3CB7EA",
    display: 'flex',
    height: '60px',
    width: '100%'
};

const headerCss = {
    color: 'black',
    fontSize: '20px',
    marginLeft: '16px', // Slightly to the right of the toggle to sollapse sidebar
    transition: 'all 0.15s ease-in',
};

const synLogoCss = {
    color: 'black',
    height: '60px',
    transition: 'all 0.15s ease-in',
};

const rightHandSideNavCss = {
  marginLeft: 'auto',
  marginRight: '10px',
};

const helpIconCss = {
    height: '25px',
    width: '25px',
    marginTop: '10px',
    marginRight: '5px',
    cursor: 'pointer',
};

const profilePictureCss = {
    borderRadius: '50%',
    height: '50px',
    width: '50px',
    marginRight: '5px',
    marginTop: '5px',
};

// in pixels
const expandedLogoSize=50;
const collapsedLogoSize=40;

// some fancy css based on the side nav expand/collapsed state
const HeaderNav = () => {

    const dispatch = useDispatch();
    const expanded = useSelector((state) => state.sidenav.expanded );
    const currentUser = useSelector((state) => state.user.currentUser );
    const [marginLeft, setMarginLeft] = useState(EXPANDED_WIDTH/2-25);
    const [helpModalOpen, setHelpModalOpen] = useState(false);
    const [theme, setTheme] = useLocalStorage('theme', 'dark');

    useEffect(() => {
        if (expanded) {
            setMarginLeft(EXPANDED_WIDTH/2-25);
        } else {
            setMarginLeft(CLOSED_WIDTH/2-20);
        }
    }, [expanded]);


    const renderProfileImage = useCallback((props, ref) => {
        return (
            <div {...props} ref={ref}>
                <img
                    style={profilePictureCss}
                    src={currentUser?.picture}
                    alt={"Your profile avatar"}
                    referrerPolicy="no-referrer"
                />
                <ArrowDownLine color="black"/>
            </div>
        );
    }, [currentUser?.picture]);

    return useMemo(() => {
        return (
            <Affix>
                <div style={outerHeaderWrapperCss}>
                    <img src={tinySyn}
                         height={expanded ? expandedLogoSize : collapsedLogoSize}
                         width={expanded ? expandedLogoSize : collapsedLogoSize}
                         alt='Synergist logo'
                         style={{...synLogoCss, marginLeft}}
                    />
                    <div style={{display: 'flex', marginLeft}}>
                        <MenuIcon
                            height={20}
                            width={20}
                            onClick={() => dispatch(setExpanded(!expanded))}
                            style={{ ...synLogoCss, cursor: 'pointer' }}
                        />
                        <Header style={headerCss}>Synergist Resume Manager</Header>
                    </div>
                    <div style={rightHandSideNavCss}>
                        <Whisper placement="left" speaker={<Tooltip>Info</Tooltip>}>
                            <InfoOutline
                                color="black"
                                style={helpIconCss}
                                onClick={() => setHelpModalOpen(true)}
                            />
                        </Whisper>
                        <Dropdown renderToggle={renderProfileImage} placement="leftStart">
                            <Dropdown.Item disabled>{currentUser?.name}</Dropdown.Item>
                            <Dropdown.Separator />
                            {/* There might be a better/cleaner way to do this, but for now just reference window */}
                            <Dropdown.Item onSelect={() => window.location.href="/profile"}>Profile</Dropdown.Item>
                            <Dropdown.Item onClick={() => {
                                setTheme(theme === "dark" ? "light" : "dark");
                                // force page refresh since this is on the ContextProvider
                                window.location.reload(false);
                            }}>
                                {theme === "dark" ?
                                <p>Toggle Light Theme</p>
                                :
                                <p>Toggle Dark Theme</p>
                            }</Dropdown.Item>
                            <Dropdown.Item onSelect={() => window.location.href="/logout"}>Logout</Dropdown.Item>
                        </Dropdown>
                    </div>
                </div>
                <TopNavInfoModal
                    open={helpModalOpen}
                    handleClose={() => setHelpModalOpen(false)}
                />
            </Affix>
        );
    }, [dispatch, expanded, helpModalOpen, marginLeft, renderProfileImage, currentUser, theme, setTheme]);
};

export default HeaderNav;